const AccountsPayableContactValues = {
  name: "",
  phone: "",
  email: "",
  sendBy: "",
};

export default AccountsPayableContactValues;
